import { render, staticRenderFns } from "./RightsStatement.vue?vue&type=template&id=488721ec&"
import script from "./RightsStatement.vue?vue&type=script&lang=js&"
export * from "./RightsStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports